import Form from 'antd/es/form';
import React from 'react';

import type { PipelineBlock, TextSplitterBlockConfig } from '@mai/types';

import { DynamicArray, NumberRange } from './shared';

interface TextSplitterBlockEditorProps {
  block: PipelineBlock & { type: 'text_splitter' };
  onConfigChange: (config: TextSplitterBlockConfig) => void;
}

export const TextSplitterBlockEditor: React.FC<
  TextSplitterBlockEditorProps
> = ({ block, onConfigChange }) => {
  const [form] = Form.useForm();

  // Initialize form with current values
  React.useEffect(() => {
    form.setFieldsValue({
      chunk_size: block.config.chunk_size || 1000,
      chunk_overlap: block.config.chunk_overlap || 200,
      separators: block.config.separators || [],
    });
  }, [block.config, form]);

  const handleValuesChange = (
    _: unknown,
    allValues: Partial<TextSplitterBlockConfig>,
  ) => {
    onConfigChange({
      ...block.config,
      chunk_size: allValues.chunk_size || 1000,
      chunk_overlap: allValues.chunk_overlap || 200,
      separators: allValues.separators,
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size="small"
      onValuesChange={handleValuesChange}
    >
      <NumberRange
        label="Chunk Size"
        name="chunk_size"
        min={1}
        max={10000}
        help="Maximum size of each chunk in characters"
      />

      <NumberRange
        label="Chunk Overlap"
        name="chunk_overlap"
        min={0}
        max={1000}
        help="Number of characters to overlap between chunks"
      />

      <DynamicArray
        label="Separators"
        name="separators"
        help="List of separators to try in order (optional)"
        placeholder="Enter separator"
      />
    </Form>
  );
};
